import { _js } from '@ifixit/localize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import {
   DropdownMenu,
   DropdownMenuContent,
   DropdownMenuItem,
   DropdownMenuTrigger,
} from '@ifixit/ui/components/dropdown-menu';
import { Tooltip, TooltipContent, TooltipTrigger } from '@ifixit/ui/components/tooltip';
import { cn } from '@ifixit/ui/lib/utils';
import { noteTypes } from '@ifixit/wiki-components/wiki-note';
import { tiptapButtonClassName } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

const headings = {
   note: _js('Note'),
   tip: _js('Tip'),
   important: _js('Important'),
   warning: _js('Warning'),
   caution: _js('Caution'),
};

export function NoteDropdown() {
   const { editor } = useEditorContext();
   const isActive = editor.isActive('note');
   const isDisabled = !editor.can().toggleNote('note');

   const handleOpenChange = (open: boolean) => {
      if (!open) {
         setTimeout(() => editor.commands.focus(), 50);
      }
   };

   return (
      <Tooltip>
         <DropdownMenu onOpenChange={handleOpenChange}>
            <TooltipTrigger asChild>
               <DropdownMenuTrigger asChild>
                  <button
                     type="button"
                     disabled={isDisabled}
                     data-active={isActive ? 'true' : undefined}
                     aria-label={_js('Insert a note')}
                     className={cn(tiptapButtonClassName, 'p-1')}
                  >
                     <span className="inline-flex items-center gap-[7px]">
                        <FontAwesomeIcon icon={faCircleInfo} />
                        <FontAwesomeIcon icon={faChevronDown} />
                     </span>
                  </button>
               </DropdownMenuTrigger>
            </TooltipTrigger>
            <DropdownMenuContent align="start">
               {noteTypes.map(type => {
                  const isCurrentType = editor.isActive('note', { type });
                  const onSelectHandler =
                     !isCurrentType && isActive
                        ? () => editor.chain().focus().setNoteType(type).run()
                        : () => editor.chain().focus().toggleNote(type).run();
                  return (
                     <DropdownMenuItem key={type} onSelect={onSelectHandler}>
                        {headings[type]}
                     </DropdownMenuItem>
                  );
               })}
            </DropdownMenuContent>
         </DropdownMenu>
         <TooltipContent side="top" align="start">
            {_js('Insert a note')}
         </TooltipContent>
      </Tooltip>
   );
}
